import { render, staticRenderFns } from "./DemoLoader.vue?vue&type=template&id=312ebd7b&"
import script from "./DemoLoader.vue?vue&type=script&lang=js&"
export * from "./DemoLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports